<script setup>
import { ref, onMounted, watch } from "vue";
import { createHighlighter } from "shiki";

const props = defineProps({
  code: String,
  lang: {
    type: String,
    default: "yaml",
  },
  theme: {
    type: String,
    default: "vitesse-dark",
  },
});

const highlightedCode = ref("");
let highlighter = null;

async function highlightCode() {
  if (!highlighter) {
    highlighter = await createHighlighter({
      themes: [props.theme],
      langs: [props.lang],
    });
  }
  highlightedCode.value = highlighter.codeToHtml(props.code, {
    lang: props.lang,
    theme: props.theme,
  });
}

async function getHighlighter() {
  return createHighlighter({
    themes: [props.theme],
    langs: [props.lang],
  });
}

onMounted(async () => {
  highlighter = await getHighlighter();
  highlightCode();
});

// Watch for `code` changes and update the highlighted output
watch(() => props.code, highlightCode);
</script>

<template>
  <div v-html="highlightedCode" />
</template>
